module.exports = __webpack_public_path__ + "img/09-02_Being Creative.7bd9471d.svg";